/**
 * UI copy: Finnish (default) and English.
 * Concert venue names are mostly proper nouns; translate descriptive bits only where noted.
 */
export const translations = {
  fi: {
    nav: {
      home: "Etusivu",
      band: "Yhtye",
      music: "Musiikki",
      live: "Keikat",
      pix: "Kuvat",
      contact: "Yhteys",
    },
    lang: {
      switchLabel: "Kieli",
      fi: "Suomi",
      en: "English",
    },
    band: {
      title: "Alinen – maailmojen välissä",
      body:
        "Alinen tulee elektronisen musiikin, ambientin, progen ja folkin rajaseuduilta. Se soutaa tummissa vesissä, harhailee muinaisissa metsissä ja etsii kauneuden välkähdyksiä betoniviidakossa. Taustalla sivilisaatio natisee liitoksissaan.\n\n" +
        "Yhtyeessä soittavat Toni Haapanen (laulu, koskettimet, akustinen kitara), Lauri Kajander (kitara, koneet) ja Heikki Pesu (koskettimet, syntetisaattori).\n\n" +
        "Alisen esikoisalbumi Vastavirtaan julkaistiin 24.4.2026 CD:nä ja suoratoistopalveluissa.",
      desibeliQuote:
        "Vastavirtaan tuli ja yllätti, sillä seitsemän raidan ja aika tarkkaan kolmen vartin mittainen albumi on haastavan ja upean kaaren piirtävä levy. Pohjoista voimaa, alista voimaa, ylistä magiikkaa ja kaiken yhdistävänä maailmanpylväänä toimii eri ajoista rakentunut musiikki.",
      desibeliReviewUrl: "https://www.desibeli.net/arvostelu/9689",
      desibeliAttribution: "Desibeli.net",
    },
    concerts: {
      heading: "Keikat",
      rows: [
        { date: "12.9.2026", venueKey: "paasikivi", city: "Kerava" },
        { date: "25.4.2026", venueKey: "lovePotion", city: "Helsinki" },
        { date: "28.2.2026", venueKey: "kalasatama", city: "Helsinki" },
        { date: "17.1.2025", venueKey: "playhouse", city: "Helsinki" },
        { date: "26.3.2024", venueKey: "playhouse", city: "Helsinki" },
        { date: "10.2.2024", venueKey: "kalasatama", city: "Helsinki" },
        { date: "28.10.2023", venueKey: "paasikivi", city: "Kerava" },
        { date: "26.11.2022", venueKey: "mascot", city: "Helsinki" },
        { date: "17.10.2022", venueKey: "asunnottomienYo", city: "vantaaTikkurila" },
        { date: "04.12.2021", venueKey: "oranssiPrivate", city: "Helsinki" },
        { date: "25.08.2021", venueKey: "vadelmagaala", city: "helsinkiCityMuseum" },
        { date: "03.08.2020", venueKey: "hanila", city: "estonia" },
      ],
    },
    concertVenues: {
      lovePotion: { name: "Love Potion Psych Fest", url: "https://biletti.fi/e/love-potion-psych-fest-helsinki" },
      kalasatama: { name: "Kalasataman vapaakaupunki", url: null },
      playhouse: { name: "Playhouse Bar", url: null },
      paasikivi: { name: "Oluthuone Paasikivi", url: null },
      mascot: { name: "Mascot Bar", url: null },
      asunnottomienYo: { name: "Vantaan Asunnottomien yö", url: null },
      oranssiPrivate: { name: "Oranssi, yksityistilaisuus", url: null },
      vadelmagaala: { name: "VadelmaGaala 2021", url: null },
      hanila: { name: "Hanila Open Air", url: null },
    },
    concertCities: {
      vantaaTikkurila: "Vantaa (Tikkurilan toriaukio)",
      helsinkiCityMuseum: "Helsinki (Kaupunginmuseo)",
      estonia: "Viro",
    },
    gallery: {
      heading: "Kuvat",
    },
    releases: {
      bandcampAlbumTitle: "Vastavirtaan – Alinen (Bandcamp)",
      videoTitles: {
        kaikenKauniin: "Alinen – Kaiken kauniin",
        mustaKivi: "Alinen – Musta kivi",
        ainut: "Alinen – Ainut",
        sulaaKultaa: "Alinen – Sulaa kultaa",
        vadelmagaalaLive: "Alinen livenä Vadelmagaalassa 21",
      },
    },
    contact: {
      heading: "Yhteys",
      gigSales: "Keikkamyynti:",
      band: "Yhtye:",
      sendMessage: "Lähetä viesti",
      namePlaceholder: "Nimi",
      emailPlaceholder: "Sähköposti",
      messagePlaceholder: "Viesti",
      send: "Lähetä",
      messageSent: "Viestisi on lähetetty, kiitos!",
      messageError:
        "Tapahtui virhe. Lähetä sähköpostia osoitteeseen alinenofficial@gmail.com.",
      emailBodyPrefix: "Viesti Alinen-yhtyeelle: ",
    },
    footer: {
      bandcamp: "Bandcamp – Alinen",
      facebook: "Facebook – Alinen",
      tidal: "Tidal – Alinen",
      spotify: "Spotify – Alinen",
      instagram: "Instagram – Alinen",
      youtube: "YouTube – Alinen",
      email: "Sähköposti – Alinen",
    },
    meta: {
      documentTitle: "Alinen",
    },
  },
  en: {
    nav: {
      home: "Home",
      band: "Band",
      music: "Music",
      live: "Live",
      pix: "Pix",
      contact: "Contact",
    },
    lang: {
      switchLabel: "Language",
      fi: "Finnish",
      en: "English",
    },
    band: {
      title: "Alinen - Between Worlds",
      body:
        "Alinen ('underworld' or 'the abode of the dead' in Finnish mythology) cultivates a blend of electronica and ambient that has its roots in traditional songwriting and folk. " +
        "The band is formed by three terrestrials, Toni Haapanen, Lauri Kajander and Heikki Pesu.\n\n" +
        "So far, Alinen has released a few singles and made live performances in Finland and Estonia. A full-length album was released on April 24th, 2026.",
      desibeliQuote:
        "Vastavirtaan arrived as a surprise: with seven tracks and a runtime of just about three quarters of an hour, the album traces a challenging and magnificent arc. Northern power, power from below, uplifting magic — and as the pillar that binds it all between worlds, music built from different eras.",
      desibeliReviewUrl: "https://www.desibeli.net/arvostelu/9689",
      desibeliAttribution: "Desibeli.net",
    },
    concerts: {
      heading: "Live",
      rows: [
        { date: "25.4.2026", venueKey: "lovePotion", city: "Helsinki" },
        { date: "28.2.2026", venueKey: "kalasatama", city: "Helsinki" },
        { date: "17.1.2025", venueKey: "playhouse", city: "Helsinki" },
        { date: "26.3.2024", venueKey: "playhouse", city: "Helsinki" },
        { date: "10.2.2024", venueKey: "kalasatama", city: "Helsinki" },
        { date: "28.10.2023", venueKey: "paasikivi", city: "Kerava" },
        { date: "26.11.2022", venueKey: "mascot", city: "Helsinki" },
        { date: "17.10.2022", venueKey: "asunnottomienYo", city: "vantaaTikkurila" },
        { date: "04.12.2021", venueKey: "oranssiPrivate", city: "Helsinki" },
        { date: "25.08.2021", venueKey: "vadelmagaala", city: "helsinkiCityMuseum" },
        { date: "03.08.2020", venueKey: "hanila", city: "estonia" },
      ],
    },
    concertVenues: {
      lovePotion: { name: "Love Potion Psych Fest", url: "https://biletti.fi/e/love-potion-psych-fest-helsinki" },
      kalasatama: { name: "Kalasataman vapaakaupunki", url: null },
      playhouse: { name: "Playhouse Bar", url: null },
      paasikivi: { name: "Oluthuone Paasikivi", url: null },
      mascot: { name: "Mascot Bar", url: null },
      asunnottomienYo: { name: "Vantaan Asunnottomien yö", url: null },
      oranssiPrivate: { name: "Oranssi, private party", url: null },
      vadelmagaala: { name: "VadelmaGaala 2021", url: null },
      hanila: { name: "Hanila Open Air", url: null },
    },
    concertCities: {
      vantaaTikkurila: "Vantaa (Tikkurila market square)",
      helsinkiCityMuseum: "Helsinki (City Museum)",
      estonia: "Estonia",
    },
    gallery: {
      heading: "Pix",
    },
    releases: {
      bandcampAlbumTitle: "Vastavirtaan by Alinen (Bandcamp)",
      videoTitles: {
        kaikenKauniin: "Alinen - Kaiken kauniin",
        mustaKivi: "Alinen - Musta kivi",
        ainut: "Alinen - Ainut",
        sulaaKultaa: "Alinen - Sulaa kultaa",
        vadelmagaalaLive: "Alinen Live at Vadelmagaala 21",
      },
    },
    contact: {
      heading: "Contact",
      gigSales: "Gig sales and bookings:",
      band: "Band:",
      sendMessage: "Send message",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      messagePlaceholder: "Message",
      send: "Send",
      messageSent: "Your message was sent, thank you!",
      messageError:
        "An error occurred. Please send email to alinenofficial@gmail.com.",
      emailBodyPrefix: "Message to Alinen: ",
    },
    footer: {
      bandcamp: "Bandcamp Alinen",
      facebook: "Facebook Alinen",
      tidal: "Tidal Alinen",
      spotify: "Spotify Alinen",
      instagram: "Instagram Alinen",
      youtube: "YouTube Alinen",
      email: "Email Alinen",
    },
    meta: {
      documentTitle: "Alinen",
    },
  },
};

export const DEFAULT_LOCALE = "fi";

export const SUPPORTED_LOCALES = ["fi", "en"];
